import { assessmentListSchema, assessmentSchema } from "../../schemas/training";
import type { UpsertAssessment } from "../../types";
import { fetchApi, fetchVoid } from "../internal";

// Per-dimension coaching assessment (concept C), served by the Rust `skills`
// service. Deliberately NOT nested under /training — a club's assessments
// are a resource of their own, staff-gated at the route.
export const assessments = {
	delete: (clubId: string, userId: string) =>
		fetchVoid(`/clubs/${clubId}/assessments/${userId}`, {
			method: "DELETE",
		}),
	get: (clubId: string, userId: string) =>
		fetchApi(`/clubs/${clubId}/assessments/${userId}`, assessmentSchema),
	list: (clubId: string) => fetchApi(`/clubs/${clubId}/assessments`, assessmentListSchema),
	upsert: (clubId: string, userId: string, data: UpsertAssessment) =>
		fetchApi(`/clubs/${clubId}/assessments/${userId}`, assessmentSchema, {
			body: JSON.stringify(data),
			method: "PUT",
		}),
};
